import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'

import type { LeaveEventLeaf } from '../../Store'
import styles from './index.module.scss'

const cx = classNames.bind(styles)

interface Props {
  employee: Employee
  leaveEventLeaf: LeaveEventLeaf
  dayClasses: Record<string, boolean>
  year: number | undefined
}

const Cell = ({ employee, leaveEventLeaf, dayClasses, year }: Props) => {
  const [open, toggle] = useToggle()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const key = leaveEventLeaf.data.leaveId
  const contentAttr: { onClick?: () => void } = {}
  const className = cx('content', dayClasses, leaveEventLeaf.contentClasses)

  const onClickCell = (_id: number, _year: number, leaveId: number) => {
    navigate(navigation.calendar.teamView.leavesEditLeaveId.fullPath({ leave_id: leaveId }))
  }

  if (leaveEventLeaf.data.canManageLeave) {
    contentAttr.onClick = () => {
      if (year !== undefined) {
        onClickCell(employee.attributes.id, year, leaveEventLeaf.data.leaveId)
      }
    }
  }

  const backgroundColor = leaveEventLeaf.data.color ?? ''

  const content = (
    <div
      className={styles.contentInner}
      style={{
        backgroundColor,
      }}
      {...contentAttr}
    />
  )

  const leaveName = leaveEventLeaf.data.leaveTypeName

  if (!leaveName) {
    return (
      <div key={key} className={className}>
        {content}
      </div>
    )
  }

  const leaveTooltip: string[] = !leaveEventLeaf.data.approved
    ? [
        i18n.t('team_view.tooltip_pending_leave', {
          leaveName,
        }),
      ]
    : [leaveName]

  if (leaveEventLeaf.data.leaveDescriptionTooltip) {
    leaveTooltip.push(leaveEventLeaf.data.leaveDescriptionTooltip)
  }

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={open}
      toggle={toggle}
      label={leaveTooltip.join(' - ')}
      className={className}
      textAlign="center"
    >
      {content}
    </Tooltip.Alt>
  )
}

export default Cell
